module.exports = __webpack_public_path__ + "static/android-icon-192x192-7b18fcafcc0d5618d97a90d32c44fee9.png";